import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ACTION_ERROR_TITLE } from '../../interceptors/http-error.interceptor';
import type { RemoteUserTripPurposeDTO } from '../../models/api/remote-user-trip-purpose.model';

@Injectable({
  providedIn: 'root',
})
export class RemoteUserTripPurposeService {
  private readonly httpClient = inject(HttpClient);
  private readonly purposeApi = `${environment.apiUrl}/v1/codebooks/remote-user-trip-purpose`;

  getRemoteUserTripPurposes(): Observable<RemoteUserTripPurposeDTO[]> {
    const context = new HttpContext().set(
      ACTION_ERROR_TITLE,
      'Failed to Get Remote User Trip Purposes',
    );

    return this.httpClient.get<RemoteUserTripPurposeDTO[]>(this.purposeApi, { context });
  }
}
